import React, { useContext, useEffect, useState } from "react";
import {
  // CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilLockLocked, cilUser } from "@coreui/icons";
//
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { AuthLogin, GETAuthLogin } from "../../features/auth/Slice";
import { useDispatch, useSelector } from "react-redux";
import SuccessModel from "../../common/model/SuccessModel";
import ErrorModel from "../../common/model/ErrorModel";
import { Col, Form, Row } from "react-bootstrap";
import CButton from "../../common/buttons/CButton";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import "./Login.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faUser } from "@fortawesome/free-solid-svg-icons";
import { Context } from "../../utils/context";
import Subscription_Check_Modal from "../../common/model/subscription_check_modal/Subscription_Check_Modal";
import Orange_Btn from "../../common/buttons/orange_btn/Orange_Btn";
import White_Btn from "../../common/buttons/white_btn/White_Btn";

const Set_New_Password = () => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);
  const [message, setMessage] = useState("");
  const [showPass, setshowPass] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const { isSidebarOpen, isAllow, signin, setSignin, GetUser } =
    useContext(Context);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
  } = useForm({});

  const navigate = useNavigate();

  const togglePassVisibility = () => {
    setshowPass((prevState) => !prevState);
  };

  const onSubmit = async (data) => {};

  useEffect(() => {
    if (auth.isLogin) {
      GetUser();
      navigate("/dashboard");
    }
  }, [auth]);

  const [showOtpDiv, setShowOtpDiv] = useState(false);

  return (
    <div className="Login Reset_Password Set_New_Password">
      <div className="main_page_holder">
        <div className="vdo_holder">
          <video
            src="/Assets/videos/login.mp4"
            className="Product_vdo"
            muted
            loop
            autoPlay
          />
        </div>

        <div className="backdrop_div">
          <img src="/Assets/Images/login/new_bg2.webp" className="bg_img" />
        </div>
        <div className="backdrop_div_dark"></div>

        {/* <div className="backdrop_div">
          <img src="/Assets/Images/login/bg.png" className="bg_img"/>
        </div> */}

        <div className="login_form">
          <div className="main_form_div">
            <p className="page_title">Reset Password</p>

            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group className="gray_input_group input_group mb-3 ">
                <div className="password_holder">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Enter New password"
                    {...register("password", {
                      required: "Password is required",
                      minLength: {
                        value: 8,
                        message: "Password must be at least 8 characters long",
                      },
                      pattern: {
                        value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                        message:
                          "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                      },
                    })}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  {errors?.password && (
                    <sup className="text-danger">
                      {errors?.password?.message}
                    </sup>
                  )}
                  <div className="eye-icc">
                    <FontAwesomeIcon
                      icon={iconOne}
                      className="icon"
                      onClick={() => togglePasswordVisibility("password")}
                    />
                  </div>
                </div>
              </Form.Group>

              <Form.Group className="gray_input_group input_group mb-5">
                <div className="password_holder">
                  <Form.Control
                    type={showPasswordOne ? "text" : "password"}
                    name="re_password"
                    placeholder="Confirm New Password"
                    {...register("re_password", {
                      required: "Re-Enter Password  is required",
                    })}
                    onChange={(e) => setPasswordAgain(e.target.value)}
                  />

                  <div className="eye-icc">
                    <FontAwesomeIcon
                      icon={iconTwo}
                      className="icon"
                      onClick={() =>
                        togglePasswordVisibility("reenterPassword")
                      }
                    />
                  </div>
                  {errors?.re_password && (
                    <sup className="text-danger">
                      {errors?.re_password?.message}
                    </sup>
                  )}
                </div>
              </Form.Group>

              <div className="footer_div two_btn">
                <White_Btn btnText="Submit" onClick={() => navigate("/")} />
                <White_Btn btnText="Cancel" onClick={() => navigate("/")} />
              </div>
            </Form>
          </div>

          <div className="white_box">
            <img
              src="/Assets/Images/sidebar/black_logo.png"
              className="logo_img"
            />
            <p className="welcome_text">Welcome to</p>
            <p className="company_text">PROFCYMA SOLUTIONS</p>
            <p className="balck_text">
              Connect your business with billions of users around the world
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Set_New_Password;
